import spartaEventsUtility from "utilities/global/sparta-events-utility/2.4.2/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import _ from "utilities/vendor/lodash/4.18.1/js/lodash.custom.min";
import * as CommonBrowserUtils from "utilities/community/common-browser-utils/1.0.0/js/common-browser-utils";
import spartaMediaQueryConstantsUtility from "utilities/global/sparta-mediaquery-constants-utility/2.0.2/js/sparta-mediaquery-constants-utility";
import currentWidgetDetails from "utilities/platform/widget-details";




export const utilityNamespace = 'spartaMediaQueryUtility';





const breakpointEventName = 'BREAKPOINT_CHANGE';





const widgetResizeEventName = 'WIDGET_RESIZE';





const EVENTS = {
  [breakpointEventName]: `${breakpointEventName}.${utilityNamespace}`,
  [widgetResizeEventName]: `${widgetResizeEventName}.${utilityNamespace}`,
};

export default EVENTS;
